import { Color } from './color.model';

export class ColorAdapter extends Color {
  constructor(data: Partial<ColorAdapter> = {}) {
    super(data);
  }
}
